<template>
  <div>
    <h4 class="mb-4">Главная страница</h4>

    <vs-row class="-mx-4">
      <vs-col
        class="w-full px-4 md:w-6/12 lg:w-2/12 xl:w-3/12 2xl:w-3/12 mb-base"
      >
        <vx-card
          title="Пропуска"
          v-if="analytics"
          class="h-full overflow-hidden"
        >
          <div slot="no-body">
            <div class="p-6 text-center">
              <feather-icon
                icon="LockIcon"
                class="p-3 inline-flex rounded-full text-primary mb-4"
                :style="{ background: `rgba(var(--vs-primary),.15)` }"
              ></feather-icon>
              <div class="">
                <h2 class="mb-1 font-bold">{{ analytics.passes }}</h2>
                <span>Всего пропусков</span>
              </div>
            </div>
          </div>
        </vx-card>
      </vs-col>

      <vs-col
        class="w-full px-4 md:w-6/12 lg:w-6/12 xl:w-5/12 2xl:w-5/12 mb-base"
      >
        <vx-card title="Жители" v-if="analytics" class="h-full overflow-hidden">
          <div slot="no-body">
            <div class="line-area-chart">
              <vue-apex-charts
                height="200"
                type="donut"
                :series="usersOptions.series"
                :options="usersOptions"
              />
            </div>
          </div>
        </vx-card>
      </vs-col>

      <vs-col
        class="w-full px-4 md:w-6/12 lg:w-4/12 xl:w-4/12 2xl:w-4/12 mb-base"
      >
        <vx-card title="Заявки" v-if="analytics" class="h-full overflow-hidden">
          <div slot="no-body">
            <div class="flex">
              <div class="p-6 w-full text-center">
                <feather-icon
                  icon="ToolIcon"
                  class="p-3 inline-flex rounded-full text-primary mb-4"
                  :style="{ background: `rgba(var(--vs-primary),.15)` }"
                ></feather-icon>
                <div class="">
                  <h2 class="mb-1 font-bold">
                    {{ analytics.applications.in_work }}
                  </h2>
                  <span>В работе</span>
                </div>
              </div>

              <div class="p-6 w-full text-center">
                <feather-icon
                  icon="CheckCircleIcon"
                  class="p-3 inline-flex rounded-full text-primary mb-4"
                  :style="{ background: `rgba(var(--vs-primary),.15)` }"
                ></feather-icon>
                <div class="">
                  <h2 class="mb-1 font-bold">
                    {{ analytics.applications.done }}
                  </h2>
                  <span>Завершены</span>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>


<script>
import VueApexCharts from "vue-apexcharts";
import chartConfigs from "@/components/statistics-cards/chartConfigs.js";

export default {
  data: () => ({
    analytics: null,
    series: [
      {
        name: "Пропусков",
        data: [1, 1],
      },
    ],

    chartOptions: null,
    usersOptions: {
      theme: {
        monochrome: {
          enabled: true,
          color: "#8276F4",
          shadeTo: "dark",
          shadeIntensity: 0.55,
        },
      },
      labels: [
        "Член клуба",
        "Не член клуба",
        "Житель",
        "Управляющий дома",
        "Должник",
      ],
      dataLabels: {
        enabled: true,
        formatter: function (value, { seriesIndex, w }) {
          return w.config.series[seriesIndex];
        },
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          donut: {
            size: "55%",
            labels: {
              show: true,
              name: {
                offsetY: 0,
              },
              value: {
                show: true,
                fontSize: "12px",
                offsetY: 0,
              },
              total: {
                show: true,
                showAlways: false,
                label: "Всего",
                fontSize: "12px",
              },
            },
          },
        },
      },
      legend: {
        show: true,
        formatter: function (seriesName, opts) {
          return [seriesName, " - ", opts.w.globals.series[opts.seriesIndex]];
        },
      },
    },
  }),
  components: {
    VueApexCharts,
  },
  methods: {
    getAnalytics() {
      this.$load(async () => {
        let res = (await this.$api.analytics.getAnalytics()).data;

        this.usersOptions.series = [
          res.users.member,
          res.users.non_member,
          res.users.resident,
          res.users.manager,
          res.users.debtor,
        ];

        this.analytics = res;
      });
    },
  },
  mounted() {
    this.getAnalytics();
  },
};
</script>